export var GuardType;
(function (GuardType) {
    GuardType[GuardType["ADMIN"] = 1] = "ADMIN";
    GuardType[GuardType["AGENT"] = 2] = "AGENT";
    GuardType[GuardType["USER"] = 10] = "USER";
})(GuardType || (GuardType = {}));
//# sourceMappingURL=GuardType.js.map